
import Navigation from '../../components/feature/Navigation';
import Footer from '../../components/feature/Footer';

const ServicePage = () => {
  const services = [
    {
      title: "브랜드 디스커버리",
      description: "미국 시장에 맞는 K-뷰티 브랜드 발굴 및 시장 분석을 통해 성공 가능성이 높은 브랜드를 선별합니다.",
      features: [
        "시장 트렌드 분석",
        "브랜드 포트폴리오 평가",
        "타겟 고객층 분석",
        "경쟁사 분석"
      ],
      icon: "ri-search-line",
      image: "https://public.readdy.ai/ai/img_res/afce188e872952fdb2d10fbdf426cd61.jpg"
    },
    {
      title: "글로벌 유통 대행",
      description: "브랜드와 글로벌 마켓을 연결하는 최적의 유통 전략을 수립하고 실행합니다.",
      features: [
        "유통 채널 설계",
        "마켓플레이스 전략",
        "가격 정책 수립",
        "재고 관리 시스템"
      ],
      icon: "ri-global-line",
      image: "https://readdy.ai/api/search-image?query=global%20distribution%20network%20visualization%2C%20international%20shipping%20and%20logistics%2C%20world%20map%20with%20connection%20lines%2C%20modern%20warehouse%20and%20distribution%20center%2C%20professional%20supply%20chain%20management&width=600&height=400&seq=service-distribution-002&orientation=landscape"
    },
    {
      title: "입점 및 운영",
      description: "eBay를 비롯한 글로벌 마켓플레이스 입점부터 일상적인 운영 관리까지 전담합니다.",
      features: [
        "마켓플레이스 입점",
        "상품 리스팅 최적화",
        "프로모션 기획 및 실행",
        "매출 분석 및 리포팅"
      ],
      icon: "ri-store-line",
      image: "https://readdy.ai/api/search-image?query=e-commerce%20marketplace%20management%20dashboard%2C%20eBay%20seller%20interface%2C%20product%20listing%20optimization%2C%20sales%20analytics%20charts%20and%20performance%20metrics%2C%20professional%20online%20store%20management&width=600&height=400&seq=service-operation-003&orientation=landscape"
    },
    {
      title: "물류/CS",
      description: "안전하고 신속한 배송부터 고객 만족을 위한 전문적인 고객 서비스까지 제공합니다.",
      features: [
        "국제 배송 관리",
        "재고 보관 및 관리",
        "고객 문의 응대",
        "클레임 및 반품 처리"
      ],
      icon: "ri-truck-line",
      image: "https://readdy.ai/api/search-image?query=modern%20logistics%20and%20customer%20service%20center%2C%20international%20shipping%20packages%2C%20professional%20customer%20support%20team%2C%20warehouse%20management%20system%2C%20efficient%20order%20fulfillment%20process&width=600&height=400&seq=service-logistics-004&orientation=landscape"
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      
      {/* Hero Section */}
      <section className="pt-32 pb-20 bg-gray-50">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-5xl md:text-6xl font-light text-black mb-6 leading-tight">
              Our Services
            </h1>
            <p className="text-xl text-gray-600 font-light">
              브랜드 발굴부터 글로벌 시장 정착까지, End-to-End 서비스
            </p>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="py-32 bg-white">
        <div className="container mx-auto px-6">
          <div className="max-w-6xl mx-auto">
            <div className="space-y-32">
              {services.map((service, index) => (
                <div key={index} className={`grid lg:grid-cols-2 gap-16 items-center ${index % 2 === 1 ? 'lg:grid-flow-col-dense' : ''}`}>
                  <div className={index % 2 === 1 ? 'lg:col-start-2' : ''}>
                    <div className="bg-gray-100 aspect-[3/2] overflow-hidden">
                      <img 
                        src={service.image}
                        alt={service.title}
                        className="w-full h-full object-cover"
                      />
                    </div>
                  </div>
                  
                  <div className={index % 2 === 1 ? 'lg:col-start-1 lg:row-start-1' : ''}>
                    <div className="space-y-6">
                      <div className="w-16 h-16 bg-black text-white flex items-center justify-center mb-6">
                        <i className={`${service.icon} text-2xl`}></i>
                      </div>
                      
                      <h2 className="text-4xl font-light text-black">{service.title}</h2>
                      
                      <p className="text-lg text-gray-600 font-light leading-relaxed">
                        {service.description}
                      </p>
                      
                      <div className="space-y-3">
                        {service.features.map((feature, featureIndex) => (
                          <div key={featureIndex} className="flex items-center space-x-4">
                            <div className="w-2 h-2 bg-black rounded-full"></div>
                            <span className="text-gray-800">{feature}</span>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Process Section */}
      <section className="py-32 bg-gray-50">
        <div className="container mx-auto px-6">
          <div className="max-w-6xl mx-auto">
            <div className="text-center mb-20">
              <h2 className="text-4xl font-light text-black mb-6">진행 프로세스</h2>
              <p className="text-lg text-gray-600 font-light">체계적이고 전문적인 프로세스로 브랜드의 성공을 보장합니다</p>
            </div>
            
            <div className="grid md:grid-cols-4 gap-8">
              <div className="text-center">
                <div className="w-20 h-20 bg-black text-white flex items-center justify-center mx-auto mb-6 text-2xl font-light">01</div>
                <h3 className="text-xl font-semibold text-black mb-3">상담 및 분석</h3>
                <p className="text-gray-600 font-light">브랜드 분석 및 시장 진출 전략 수립</p>
              </div>
              <div className="text-center">
                <div className="w-20 h-20 bg-black text-white flex items-center justify-center mx-auto mb-6 text-2xl font-light">02</div>
                <h3 className="text-xl font-semibold text-black mb-3">계약 및 준비</h3>
                <p className="text-gray-600 font-light">파트너십 체결 및 런칭 준비</p>
              </div>
              <div className="text-center">
                <div className="w-20 h-20 bg-black text-white flex items-center justify-center mx-auto mb-6 text-2xl font-light">03</div>
                <h3 className="text-xl font-semibold text-black mb-3">런칭 및 운영</h3>
                <p className="text-gray-600 font-light">마켓플레이스 런칭 및 운영 시작</p>
              </div>
              <div className="text-center">
                <div className="w-20 h-20 bg-black text-white flex items-center justify-center mx-auto mb-6 text-2xl font-light">04</div>
                <h3 className="text-xl font-semibold text-black mb-3">성장 및 확장</h3>
                <p className="text-gray-600 font-light">매출 증대 및 시장 확장</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ServicePage;
